import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaHome,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const RealEstateVideographyInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Real Estate Videography in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Showcase Your Properties</Subheading>}
        heading={
          <Heading>
            Professional{" "}
            <span tw="text-primary-500">Real Estate Videography</span> in Al
            Barsha
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we offer professional real estate videography in
            **Al Barsha**, creating stunning, high-quality videos that highlight
            your properties and attract buyers. Elevate your listings with
            videos that sell.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1560184897-ae75f418493e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Modern Dubai property
          "https://images.unsplash.com/photo-1582610116397-edb318620f90?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Luxury apartment in Dubai
          "https://images.unsplash.com/photo-1600607687644-c7f34b5063c7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Elegant interior design
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Showcase Your Property"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Real Estate Videography in Al Barsha"
        description="We produce real estate videos that captivate and convert."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Cinematic Quality",
            description: "High-definition videos with professional editing.",
          },
          {
            icon: <FaHome color="#ff5464" size={40} />,
            title: "Property Highlight",
            description: "Showcase every detail to attract buyers.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Increased Engagement",
            description: "Videos designed to boost listing views.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Delivery",
            description: "Quick turnaround for urgent listings.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile Optimized",
            description: "Videos tailored for all devices.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted by Agents",
            description: "Al Barsha’s choice for real estate videos.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Professional Videography Process"
        description={
          <Description>
            We create impactful real estate videos with a refined approach:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your property and goals.</li>
              <li>Planning: Develop a shot list and storyboard.</li>
              <li>Filming: Capture stunning footage of your property.</li>
              <li>Editing: Enhance with music, text, and effects.</li>
              <li>Delivery: Provide ready-to-share videos.</li>
              <li>Support: Offer updates and optimization.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Property interior view
          "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Modern building exterior
          "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Stylish apartment living room
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Real Estate Wins in Al Barsha"
        description="Our videos have transformed property marketing."
        cards={[
          {
            icon: <FaHome color="#ff5464" size={40} />,
            title: "Faster Sales",
            description: "Sold properties faster with engaging videos.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Higher Views",
            description: "Doubled listing views for an Al Barsha agent.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Praise",
            description: "97% satisfaction from real estate clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Sell Faster?</Subheading>}
        heading="Real Estate Videography in Al Barsha"
        description={
          <Description>
            Partner with MilaajBrandset for professional real estate videography
            in Al Barsha. Get high-quality videos that showcase your properties
            and attract buyers—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Luxury villa
          "https://images.unsplash.com/photo-1600210492493-0946911123ea?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Modern kitchen design
          "https://images.unsplash.com/photo-1464938050520-ef2270bb8ce8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Dubai skyline with property
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
